import { getStorageAt } from '@wagmi/core'
import type { Address } from 'viem'
import { getAddress } from 'viem'
import {
  EIP_1967_IMPLEMENTATION_SLOT,
  PRE_EIP_1967_IMPLEMENTATION_SLOT,
  NON_PROXY_CONTRACT_IMPLEMENTATION_ADDRESS,
  EIP_1967_BEACON_SLOT,
} from 'constants/common'
import { zircuit } from 'constants/network'
import { publicClientL2 } from 'lib/viem'
import { wagmiConfig } from 'lib/wagmi'

const IMPLEMENTATION_ABI = [
  {
    name: 'implementation',
    type: 'function',
    stateMutability: 'view',
    outputs: [{ type: 'address' }],
  },
] as const

// Inspired by: https://medium.com/@MRG_DevWeb3.co/retrieving-implementation-contract-addresses-from-proxy-contracts-in-evm-networks-934cd2c659d5
// More context: https://eips.ethereum.org/EIPS/eip-1967
export const getProxyImplementationAddress = async (hash: Address): Promise<Address | null> => {
  const eip1967Address = await getStorageAt(wagmiConfig, {
    address: hash as Address,
    slot: EIP_1967_IMPLEMENTATION_SLOT,
    chainId: zircuit.id,
  })

  const preEip1967Address = await getStorageAt(wagmiConfig, {
    address: hash as Address,
    slot: PRE_EIP_1967_IMPLEMENTATION_SLOT,
    chainId: zircuit.id,
  })

  const beaconProxyAddress = await getStorageAt(wagmiConfig, {
    address: hash as Address,
    slot: EIP_1967_BEACON_SLOT,
    chainId: zircuit.id,
  })

  if (eip1967Address && eip1967Address !== NON_PROXY_CONTRACT_IMPLEMENTATION_ADDRESS) {
    return getAddress(`0x${eip1967Address.slice(-40)}`)
  }

  if (preEip1967Address && preEip1967Address !== NON_PROXY_CONTRACT_IMPLEMENTATION_ADDRESS) {
    return getAddress(`0x${preEip1967Address.slice(-40)}`)
  }

  if (beaconProxyAddress && beaconProxyAddress !== NON_PROXY_CONTRACT_IMPLEMENTATION_ADDRESS) {
    try {
      const implementationAddressHex = (await publicClientL2.readContract({
        address: `0x${beaconProxyAddress.slice(-40)}`,
        abi: IMPLEMENTATION_ABI,
        functionName: 'implementation',
      })) as Address

      return getAddress(implementationAddressHex)
    } catch {
      return null
    }
  }

  return null
}
